import React from 'react'
import { Box } from '@mui/material'
import header from "../../../images/kiosk_header.png";

function KioskHeader() {
    return (
        <>
            <Box
                sx={{
                    bgcolor: "#8b0000",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <img
                    src={header}
                    alt="header"
                />
            </Box>
        </>
    )
}

export default KioskHeader;